import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Referral from './components/Referral';
import ListAffiliate from './components/ListAffiliate';
import ProtectedRoute from './components/ProtectedRoute';
import UserManagement from './components/UserManagement';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* New Referral route */}
          <Route 
            path="/referral" 
            element={
              <ProtectedRoute>
                <Referral />
              </ProtectedRoute>
            } 
          />
          
          {/* Role-protected routes */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requiredRoles={['admin']}>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/referral-management" 
            element={
              <ProtectedRoute requiredRoles={['admin', 'referral_manager']}>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/analytics" 
            element={
              <ProtectedRoute requiredRoles={['admin', 'analyst']}>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/voucher-management" 
            element={
              <ProtectedRoute requiredRoles={['admin', 'referral_manager']}>
                <Dashboard />
              </ProtectedRoute>
            } 
          />


          <Route 
            path="/user-management" 
            element={
              <ProtectedRoute requiredRoles={['admin']}>
                <UserManagement />
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/list-referral" 
            element={
              <ProtectedRoute requiredRoles={['referral_manager']}>
                <ListAffiliate />
              </ProtectedRoute>
            } 
          />
          
          {/* Redirect root to dashboard if logged in, otherwise to login */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
